




















































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import UiList from '@superUI/List/List'
import CampaignCard from '@ui/cards/CampaignCard'
import CampaignDraftCard from '@ui/cards/CampaignDraftCard'
import RemoveCampaignFormTriggerModal from '@triggers/CampaignForm/RemoveCampaignFormTriggerModal'
import RemoveCampaignTriggerModal from '@triggers/Campaign/RemoveCampaignTriggerModal'
import DuplicateCampaignTriggerModal from '@triggers/Campaign/DuplicateCampaignTriggerModal'

settings =
  name: 'CampaignList'

  resources:
    campaigns:
      resourceName: 'campaign'
      slug: 'campaigns'
      params:
        limit: 100

    form_campaign:
      resourceName: 'form_campaign'
      slug: 'form_campaign'

  vue:
    store: ['member']
    components: {
      LoadingIndicator,
      UiList,
      CampaignCard,
      CampaignDraftCard,
      RemoveCampaignFormTriggerModal,
      RemoveCampaignTriggerModal,
      DuplicateCampaignTriggerModal
    }

    computed:
      brandRepId: -> @member?.brand_rep?.id
      persistedFormCampaign: -> @form_campaign?.persisted

      actionsForCampaignDraftCard: ->
        {
          remove: @removeCampaignFormTrigger
        }

      actionsForCampaignCard: ->
        {
          remove: @removeCampaignTrigger,
          duplicate: @duplicateCampaignTrigger
        }

    methods:
      removeCampaignFormTrigger: ->
        payloadOptions = { form_campaign_id: @form_campaign.id }
        @$refs.removeCampaignFormTrigger.fire(payloadOptions)
      onFormCampaignRemoveFormCampaign: ->
        @$refs.removeCampaignFormTrigger.close()
        @fetch('form_campaign')

      removeCampaignTrigger: (campaign) ->
        payloadOptions = { campaign_id: campaign.id }
        modalOptions = { campaign }
        @$refs.removeCampaignTrigger.fire(payloadOptions, modalOptions)
      onRemoveCampaign: ->
        @$refs.removeCampaignTrigger.close()
        @fetch('campaigns')

      duplicateCampaignTrigger: (campaign) ->
        payloadOptions = { campaign_id: campaign.id }
        modalOptions = { campaign }
        @$refs.duplicateCampaignTrigger.fire(payloadOptions, modalOptions)
      onDuplicateCampaign: ->
        @$refs.duplicateCampaignTrigger.close()
        query = { step: 'date' }
        query.brandRepId = @campaign.owner.id if @currentMemberIsSuperUser()
        @$router.push({ name: 'CampaignCreatePage', query })

export default VueOptions.vue settings
